import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { RecordPaymentWizard } from "./RecordPaymentWizard";

export function RecordPaymentFAB({ onSuccess }: { onSuccess?: () => void }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setOpen(true)}
        aria-label="Record Payment"
        style={{
          background: "linear-gradient(135deg, var(--cp-accent), var(--cp-accent-2))",
        }}
        className="fixed bottom-[calc(58px+1rem+env(safe-area-inset-bottom))] right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full text-white shadow-[var(--cp-shadow-lg)] hover:brightness-110 md:bottom-[calc(1.5rem+env(safe-area-inset-bottom))] md:right-6"
      >
        <Plus className="h-6 w-6" />
      </motion.button>
      <RecordPaymentWizard
        open={open}
        onOpenChange={setOpen}
        onSuccess={() => onSuccess?.()}
      />
    </>
  );
}
